import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { MeatballMenuItem } from './meatball-menu-item';
export const DefaultMeatballMenu = ({
  items
}) => /*#__PURE__*/React.createElement(DropdownItemGroup, null, items.map(({
  children,
  ...itemProps
}, i) =>
/*#__PURE__*/
// eslint-disable-next-line react/no-array-index-key
React.createElement(MeatballMenuItem, _extends({
  key: i
}, itemProps), children)));